import React from 'react';
import PropTypes from 'prop-types';
import { SOCIAL_MEDIA_ICONS } from '@/utils';
import isEmpty from 'lodash/isEmpty';
import DetailsCard from '@/components/EntityModal/DetailsCard';
import SocialMediaPopoverFull from '@/components/EntityModal/SocialMediaPopoverFull';
import SocialMediaPopover from '@/components/EntityModal/SocialMediaPopover';

const propTypes = {
  contact: PropTypes.object,
  onEditContact: PropTypes.func
};

const defaultProps = {
  contact: {},
  onEditContact: () => {}
};

function SocialMediaList({ contact, onEditContact }) {
  if (isEmpty(contact)) {
    return null;
  }

  return (
    <DetailsCard title='Redes Sociais' className='mt-3'>
      <div className='d-flex w-100 align-items-center'>
        <div className='d-flex flex-wrap gap-2 flex-grow-1'>
          {Object.entries(SOCIAL_MEDIA_ICONS).map(([label, icon]) => (
            <SocialMediaPopover
              key={label}
              icon={icon}
              label={label}
              socialMedia={contact[label]}
              onEditContact={onEditContact}
              contact={contact}
            />
          ))}
        </div>

        <div className='ms-auto'>
          <SocialMediaPopoverFull
            onEditContact={onEditContact}
            contact={contact}
          />
        </div>
      </div>
    </DetailsCard>
  );
}

SocialMediaList.propTypes = propTypes;
SocialMediaList.defaultProps = defaultProps;

export default SocialMediaList;
